import firebase from 'firebase';

const config = {
    apiKey: 'AIzaSyBdJRsnUapWUeFWSePHjrxdkFKXBDxzA-0',
    authDomain: 'meal-prep-9b30a.firebaseapp.com',
    databaseURL: 'https://meal-prep-9b30a.firebaseio.com',
    projectId: 'meal-prep-9b30a',
    storageBucket: '',
    messagingSenderId: '335187018575'
};
firebase.initializeApp(config);
